module.exports = {
      id: "ic-10-index-v-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-10-index-v-usage",
      toString: function () {
        return this.url;
      }
    }